import { Component, ElementRef, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { environment } from '@env/environment';

@Component({
  selector: 'open-weathermap',
  templateUrl: './openweathermap.component.html',
  styleUrls: ['./openweathermap.component.scss'],
})
export class OpenweathermapComponent implements OnInit {
  public privacyDetails: any = { bannerImage: null, bannerTitle: null, content: null };
  images: any = [];
  data: any = [];
  hours: any = [];
  geocodes: any[];
  point: any[];
  city: string;
  currLat: number;
  currLng: number;
  temp: number;
  weather: string;
  weatherimg: string;
  todaydate: Date;
  openweathermapimageurl: string | null = environment.weatherImageURL;

  constructor(public productService: ProductService, private elementRef: ElementRef) {}
  activeIndex: any;

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];
  displayCustom: boolean;

  ngOnInit(): void {
    this.productService.getPosition().then((pos) => {
      if (pos.lng != null && pos.lat != null) {
        this.OpenWeatherMap(pos.lat, pos.lng);
        this.OpenWeatherMapTemp(pos.lat, pos.lng);
      }
    });
  }

  OpenWeatherMap(lati: number, lng: number) {
    this.productService.getopenweathermap(lati, lng).then((data) => {
      if (data) {
        for (let i = 1; i < 7; i = i + 1) {
          this.hours.push({
            dt_txt: data.list[i].dt_txt,
            temp: data.list[i].main.temp,
            icon: this.openweathermapimageurl + 'img/w/' + data.list[i].weather[0].icon + '.png',
          });
        }
      }
    });
  }

  OpenWeatherMapTemp(lati: number, lng: number) {
    this.productService.getopenweathermaptmpc(lati, lng).then((datar) => {
      if (datar) {
        this.city = datar.name;
        this.temp = Math.ceil(datar.main.temp);
        this.weather = datar.weather[0].main;
        this.weatherimg = this.openweathermapimageurl + 'img/w/' + datar.weather[0].icon + '.png';
        this.todaydate = new Date();
        //console.log(new Date(datar.dt));
      }
    });
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
}
